import { observer } from "mobx-react-lite";
import styles from "./OverlayError.module.css";
import { dataBaseStore } from "@/stores/DataBaseStore";
import DataBaseErrorSVG from "./db-error.svg?react";
import CopySVG from "./copy.svg?react";
import { useRef } from "react";

export const OverlayError = observer(() => {
  const bodyRef = useRef<HTMLDivElement>(null);
  console.log("render OverlayError");

  const reload = () => {
    dataBaseStore.dbConnected();
  };

  const select = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.currentTarget as HTMLElement;
    // Проверяем, что элемент существует
    if (!target) return;
    const range = document.createRange();
    range.selectNodeContents(target);
    const selection = window.getSelection();
    if (!selection) return;
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const copy = (e: React.MouseEvent) => {
    const container = e.currentTarget.parentNode as HTMLDivElement;

    const copyNode = container.cloneNode(true) as HTMLDivElement;
    copyNode.classList.add(styles.copyNode);
    Object.assign(copyNode.style, {
      position: "fixed",
      width: container.clientWidth + "px",
      marginTop: "0px",
      marginLeft: "0px",
      top: `${container.getBoundingClientRect().top}px`,
      left: `${container.getBoundingClientRect().left}px`,
      backgroundColor: "#168e6e",
      zIndex: "9999",
    });

    if (bodyRef.current) {
      bodyRef.current.appendChild(copyNode);
      navigator.clipboard.writeText(dataBaseStore.messageError);
      copyNode.addEventListener("animationend", nodeUnmount);

      function nodeUnmount(e: AnimationEvent) {
        console.log(e.animationName);

        copyNode.removeEventListener("animationend", nodeUnmount);
        bodyRef.current?.removeChild(copyNode);
      }
    }
  };

  return (
    <div className={styles.overlayError}>
      <div ref={bodyRef} className={styles.bodyError}>
        <DataBaseErrorSVG />
        <span>{dataBaseStore.message}</span>
        <button className={styles.refresh} onClick={reload}>
          Повторить
        </button>

        {dataBaseStore.errorCode && (
          <div className={styles.bottomError}>
            <p>Сообщите вашему администратору код ошибки:</p>
            <div className={styles.errorCodeBox}>
              <span onClick={select}>{dataBaseStore.errorCode}</span>
              <CopySVG onClick={copy} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
